var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stift__Icn/40px/Stift",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stift__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Stift__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stift__Icn/40px/Plus-Tools",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Stift__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stift__Group-Copy",
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8446118,1.69335058 C16.2865476,0.251414734 18.6243875,0.251414734 20.0663234,1.69335058 L21.3717513,2.99877848 C22.8136871,4.44071433 22.8136871,6.77855425 21.3717513,8.2204901 L9.46299843,20.129243 L0.758129061,22.8687981 L2.90924619,13.6287162 Z M4.62612906,14.5218987 L4.58831895,14.5592319 L3.2900709,20.135476 L8.47811335,18.5027665 L8.54212906,18.4378987 L4.62612906,14.5218987 Z M13.3921291,5.7548987 L5.93112906,13.2158987 L9.84712906,17.1318987 L17.3091291,9.6718987 L13.3921291,5.7548987 Z M18.7608955,2.99877848 C18.0399276,2.27781056 16.8710076,2.27781056 16.1500397,2.99877848 L14.6971291,4.4498987 L18.6141291,8.3668987 L20.0663234,6.9150622 C20.7125691,6.26881644 20.779547,5.26265975 20.2672569,4.5418106 L20.1644143,4.41015236 L20.0663234,4.30420639 Z",
    id: ".._.._src_svg_Icn_40px_Stift__Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStift);
export default __webpack_public_path__ + "static/media/Stift.cf04506214e33dd4056d9fc426c64445.svg";
export { ForwardRef as ReactComponent };